import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';

const TermsPanel = ({
  disabled,
  locale,
  registrationItems,
  setConsentValidity,
}) => {
  const [explicitPolicies, setExplicitPolicies] = useState([
    ...registrationItems.explicitPolicies,
  ]);
  const [newsletters, setNewsletters] = useState([
    ...registrationItems.newsletters,
  ]);
  const isROW = locale === 'ROW';

  // Assumes all explicit policies have to be checked to be considered valid terms
  const termsValid = () => explicitPolicies.every((p) => p.checked);

  // Call function passed in via props from parent component to indicate whether or not the terms are valid
  const informConsentValidity = () => {
    setConsentValidity(termsValid(), {
      implicitPolicies: registrationItems.implicitPolicies,
      explicitPolicies,
      newsletters,
    });
  };

  // Generic checkbox handler that sets the appropriate checked property for the matching item in the 'propertyArray'
  const toggleCheckbox = (event, property, propertyArray) => {
    const { id: targetId, checked: targetChecked } = event.target;
    const updateMethods = {
      explicitPolicies: setExplicitPolicies,
      newsletters: setNewsletters,
    };
    updateMethods[property]([
      ...propertyArray.map((item) => {
        if (item.id === targetId) item.checked = targetChecked;
        return item;
      }),
    ]);

    informConsentValidity();
  };

  const getImplicitRenderPolicies = (className) => (
    <div className={className} key="div-terms-heading">
      {registrationItems.implicitPolicies.map(renderPolicyItemReadOnly)}
    </div>
  );

  const renderCheckbox = (property, propertyArray, item, required = true) => (
    <label className="checkbox" key={item.id}>
      <input
        required={required}
        type="checkbox"
        name={item.id}
        id={item.id}
        value={item.id}
        checked={item.checked}
        onChange={(e) => toggleCheckbox(e, property, propertyArray)}
        disabled={disabled}
      />
      <div className="checkbox__indicator">
        <div className="checkbox__icon">
          <IconSvg type="checkmark" />
        </div>
      </div>
      <span
        className="checkbox__text"
        htmlFor={item.id}
        dangerouslySetInnerHTML={{ __html: item.text }}
      />
    </label>
  );

  const renderPolicyItemReadOnly = (item) => (
    <div key={item.id} dangerouslySetInnerHTML={{ __html: item.text }} />
  );

  const renderExplicitPolicy = (item) =>
    renderCheckbox('explicitPolicies', explicitPolicies, item);

  const renderNewsletter = (item) =>
    renderCheckbox('newsletters', newsletters, item, false);

  useEffect(informConsentValidity, []);

  return (
    <div className="terms__container">
      {isROW && getImplicitRenderPolicies('terms__text')}
      {explicitPolicies.map(renderExplicitPolicy)}
      {newsletters.map(renderNewsletter)}
      {!isROW && getImplicitRenderPolicies('terms__text')}
    </div>
  );
};

TermsPanel.propTypes = {
  disabled: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  registrationItems: PropTypes.object.isRequired,
  setConsentValidity: PropTypes.func.isRequired,
};

export default TermsPanel;
